const market_data_seller_users = 'market_data_seller_users';
const market_data_through_admin_only = 'market_data_through_admin_only';
const tbd_93791_webapp_papertrail_logs = 'tbd_93791_webapp_papertrail_logs';
const use_lower_resolution_cr_thumbnails = 'use_lower_resolution_cr_thumbnails';
const code_boost_iq_feature = 'code_boost_iq_feature';
const audio_boost_promotional_design = 'audio_boost_promotional_design';
const segment_page_view_enabled = 'segment_page_view_enabled';
const tbd_109175_solr_watchlist = 'tbd_109175_solr_watchlist';
const tbd_125231_ws_on_marketplace = 'tbd_125231_ws_on_marketplace';
const search_instant_notifications = 'search_instant_notifications';
const tbd_150312_featured_vehicles_campaigns = 'tbd_150312_featured_vehicles_campaigns';
const enableDisconnectionToast = 'tbd_169282_react_dissconnection_toast';
const showSimilarVehiclesRecommendations = 'similar_vehicles_recommendation_react';
const fall_2024_dealer_radio_removal = 'fall_2024_dealer_radio_removal';
const tbd_187929_unified_marketplace_react = 'tbd_187929_unified_marketplace_react';
const buyer_market_report = 'buyer_market_report';
const tbd_256190_manage_saved_searches_modal = 'tbd_256190_manage_saved_searches_modal';
const NSR_Form_Banner_Transport_Dashboard = 'NSR_Form_Banner_Transport_Dashboard';
const tbd_267054_new_offer_modals = 'tbd_267054_new_offer_modals';
const tbd_261946_show_following_tab = 'tbd_261946_show_following_tab';
const wheres_my_car = 'wheres_my_car';
const address_autocomplete_signup = 'address_autocomplete_signup';
const auction_access_onboarding_enabled = 'auction_access_onboarding_enabled';
const enable_nsr_structured_addresses = 'enable_nsr_structured_addresses';
const buy_170_checkout_2_0_react = 'buy_170_checkout_2_0_react';
const cr_export_phase_1 = 'cr_export_phase_1';
const buy_380_pricing_forecast = 'buy_380_pricing_forecast';
const tbd_2629_use_pp_model_range = 'tbd_2629_use_pp_model_range';
const buy_1085_offer_update_animation = 'buy_1085_offer_update_animation';
const buy_663_okta_only_login_react = 'buy_663_okta_only_login_react';
const backend_driven_offer_payload_react = 'backend_driven_offer_payload_react';
const backend_driven_auction_offer_payload_react = 'backend_driven_auction_offer_payload_react';
const react_log_processing_for_debug = 'react_log_processing_for_debug';
const new_vehicle_bulk_edit_page = 'new_vehicle_bulk_edit_page';
const new_settings_page_react = 'new_settings_page_react';
const enable_seller_disclosures_edit_ui = 'enable_seller_disclosures_edit_ui';
const transactions_ledger = 'transactions_ledger';
const deal_driver_goodwill = 'deal_driver_goodwill';
const deal_driver_recommended_priority = 'deal_driver_recommended_priority';
const tbd_2883_prevent_minimum_bids_in_pending_auctions = 'tbd_2883_prevent_minimum_bids_in_pending_auctions';
const retail_vdp_react = 'retail_vdp_react';

export const treatments = {
	market_data_seller_users,
	market_data_through_admin_only,
	tbd_93791_webapp_papertrail_logs,
	use_lower_resolution_cr_thumbnails,
	code_boost_iq_feature,
	audio_boost_promotional_design,
	segment_page_view_enabled,
	tbd_109175_solr_watchlist,
	tbd_125231_ws_on_marketplace,
	search_instant_notifications,
	tbd_150312_featured_vehicles_campaigns,
	enableDisconnectionToast,
	showSimilarVehiclesRecommendations,
	fall_2024_dealer_radio_removal,
	tbd_187929_unified_marketplace_react,
	buyer_market_report,
	tbd_256190_manage_saved_searches_modal,
	NSR_Form_Banner_Transport_Dashboard,
	tbd_267054_new_offer_modals,
	tbd_261946_show_following_tab,
	wheres_my_car,
	address_autocomplete_signup,
	auction_access_onboarding_enabled,
	enable_nsr_structured_addresses,
	buy_170_checkout_2_0_react,
	cr_export_phase_1,
	buy_380_pricing_forecast,
	tbd_2629_use_pp_model_range,
	buy_1085_offer_update_animation,
	buy_663_okta_only_login_react,
	backend_driven_offer_payload_react,
	backend_driven_auction_offer_payload_react,
	react_log_processing_for_debug,
	new_vehicle_bulk_edit_page,
	new_settings_page_react,
	enable_seller_disclosures_edit_ui,
	transactions_ledger,
	deal_driver_goodwill,
	deal_driver_recommended_priority,
	tbd_2883_prevent_minimum_bids_in_pending_auctions,
	retail_vdp_react,
};

export const marketDataTreatments = [market_data_seller_users, market_data_through_admin_only];
export const vdpTreatments = [
	use_lower_resolution_cr_thumbnails,
	showSimilarVehiclesRecommendations,
	code_boost_iq_feature,
	audio_boost_promotional_design,
	tbd_187929_unified_marketplace_react,
	buyer_market_report,
	tbd_267054_new_offer_modals,
	backend_driven_offer_payload_react,
	cr_export_phase_1,
	buy_380_pricing_forecast,
	tbd_2629_use_pp_model_range,
	buy_1085_offer_update_animation,
	tbd_2883_prevent_minimum_bids_in_pending_auctions,
	react_log_processing_for_debug,
	retail_vdp_react,
];
export const auctionTreatments = [
	tbd_93791_webapp_papertrail_logs,
	tbd_109175_solr_watchlist,
	search_instant_notifications,
	tbd_256190_manage_saved_searches_modal,
	enableDisconnectionToast,
	enable_seller_disclosures_edit_ui,
];
